/**
 * @generated SignedSource<<b71737a0bc340761235d68ca33dc789c>>
 * @relayHash 98222dd3d529403a68f6c8a52a184c1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 65ac2089d5ffd55465acb02784515a40f387ccad09ba3c4802db0b1007b826e9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessAttachmentsQuery } from './src_jiraBusinessAttachmentsQuery.graphql';

import blockAttachmentDownloadSegregation_provider from '@atlassian/jira-relay-provider/src/block-attachment-download-segregation.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "65ac2089d5ffd55465acb02784515a40f387ccad09ba3c4802db0b1007b826e9",
    "metadata": {},
    "name": "src_jiraBusinessAttachmentsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcblockattachmentdownloadsegregationrelayprovider": blockAttachmentDownloadSegregation_provider
    }
  }
};

export default node;
